import React from 'react';

export function ErrorMessage({ message }) {
  if (!message) return null;
  
  return (
    <div className="mt-4 p-4 bg-red-50 border-l-4 border-red-500 rounded">
      <p className="text-red-700 font-medium">{message}</p>
    </div>
  );
}
